import React, { useState, Suspense } from 'react';
import NotificationTemplateForm from 'features/crm/components/notification-templates/NotificationTemplateForm';
import NotificationsList from 'features/crm/components/notifications/NotificationsList';
import Tooltip from 'shared/ui/Tooltip';
import Loading from 'shared/ui/Loading';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { Info } from 'lucide-react';




const Notifications = () => {
  const { currentColor } = useStateContext();
  const { openModal } = useLayout();

  const handleAddNotificationTemplate = () => {
    openModal({
      component: <NotificationTemplateForm />,
      title: 'Добавить уведомление',
    });
  };
  return (
    <>
      <Suspense fallback={<Loading/>}>

      <div className='bg-gray-100 py-4 px-6 flex justify-between items-center relative'>
        <div className='flex items-center relative'>
          <Tooltip trigger='click' className='mr-2'>
            <button className='text-gray-700 hover:text-gray-900 mr-2 mt-1'>
              <Info size={20} />
            </button>
          </Tooltip>
          <h1 className='text-2xl font-bold'>Уведомления</h1>
          
        </div>
      </div>
        
        <NotificationsList/>
      </Suspense>
    </>
  );
};

export default Notifications;
